import {ErrorHandler, Injectable, Injector} from '@angular/core';
import { isDevMode } from '@angular/core';
import {HttpErrorResponse} from '@angular/common/http';
import {LocationStrategy, PathLocationStrategy} from '@angular/common';
import {LoggerService} from '../service/logger.service';
import {Router} from '@angular/router';
import * as StackTraceParser from 'error-stack-parser';

@Injectable()
export class GlobalErrorHandler implements ErrorHandler {

  constructor(private injector: Injector) {}

  handleError(error) {
    this.reloadOnChunkError(error);
    if (!(error instanceof HttpErrorResponse)) {
      const location = this.injector.get(LocationStrategy);
      const logger = this.injector.get(LoggerService);
      const router = this.injector.get(Router);

      const name = error.name || 'Error name not specified';
      const url = location instanceof PathLocationStrategy ? location.path() : '';
      const message = error.message || error.toString();
      console.error(error);
      logger.clientError(name, url, message, StackTraceParser.parse(error));
      router.navigateByUrl('error-page');
    }
  }

  private reloadOnChunkError(error) {
    const chunkFailedMessage = /Loading chunk [\d]+ failed/;

    if (chunkFailedMessage.test(error.message)) {
      window.location.reload();
    }
  }
}
